var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.54 21.55a33.24 33.24 0 0 0-4.82-7.41c-.73-.57-2.25-.32-3.15-.12.11-.67 0-2.14-.66-1.88a.34.34 0 0 0-.18.45 2.14 2.14 0 0 1-.09 1.7.28.28 0 0 0-.13.21 2.23 2.23 0 0 1-3.18.6 1.56 1.56 0 0 1-.56-2.34 2.49 2.49 0 0 1 1.56-1.27 2.2 2.2 0 0 1 2 .34.3.3 0 1 0 .35-.48 3.45 3.45 0 0 0-1.16-.63 3.6 3.6 0 0 0-2.22.28c-.47-.43-1.67-1.68-1.56-2.3a51.21 51.21 0 0 1 3.75-7.49s.15 0 .2 0 0-.05 0-.06c.22-.07.09 6.23-.22 8.64a.34.34 0 0 0 .68.1 53.52 53.52 0 0 0 .66-8.8 1.25 1.25 0 0 0-2.26-.58 32.82 32.82 0 0 0-3.64 8c-.09 1 1.09 2.13 1.82 2.75-1.91 1.44-1.93 4 .49 5-.11.64-.51 2.29-1.1 2.56s-8.69 1.55-8.62 1c0 0 0 .06 0 0s5.25-3.45 7.5-4.55a.34.34 0 0 0-.29-.62c-1 .45-7.86 3.84-8.24 4.8a1.26 1.26 0 0 0 1.13 1.74 35 35 0 0 0 8.88-1.58c.88-.46 1.23-2.13 1.36-3.11a3.07 3.07 0 0 0 3.54-1.78c.63-.13 2.33-.38 2.81.06A51.43 51.43 0 0 1 22.48 22s-.06.09-.11.1-.33-.15-.61-.31a65.64 65.64 0 0 1-6.66-4.69.34.34 0 0 0-.46.51c.86.8 6.65 5.63 7.67 5.61a1.25 1.25 0 0 0 1.23-1.67Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.54a.3.3 0 0 0 .59-.13 8.5 8.5 0 0 1 1.34-5.69 4.4 4.4 0 0 1 2.18-1.55.35.35 0 0 0 0-.69 3.17 3.17 0 0 0-.85.24c-3.13.8-4.2 4.54-3.26 7.82Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.43 7.87a4.47 4.47 0 0 1 2.41 1.21 8.59 8.59 0 0 1 2.23 5.42.3.3 0 0 0 .6 0c.51-4.26-1.92-7-4.46-7.23a2.54 2.54 0 0 0-.88-.1.34.34 0 1 0 .1.7Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.85 21.19-.51.43c-2 1.92-6.47 1.35-7.7-.12a.31.31 0 0 0-.42-.07c-.58.42 1.67 2.51 4.37 2.57a5.49 5.49 0 0 0 4.32-1.86c.15-.19.44-.37.56-.67a.34.34 0 1 0-.62-.28Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12.83c0-.15.09-.21.33-.93A2.7 2.7 0 0 1 7 10.46a.34.34 0 1 0-.3-.61 2.8 2.8 0 0 0-1.78 2c-.1.47-.14 1.9.28 2.1a.3.3 0 0 0 .39-.46c.15-.05.13-.55.16-.66Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.27 13.28c.39-.26.11-1.68-.06-2.12a2.79 2.79 0 0 0-2.07-1.69.34.34 0 1 0-.2.65 2.75 2.75 0 0 1 1.11 1.29c.36.68.4.7.47.87s.1.6.29.61a.31.31 0 0 0 .46.39Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23 21.22a4.63 4.63 0 0 0 1.66.61 2.9 2.9 0 0 0 2.53-1 .34.34 0 0 0-.47-.5 2.77 2.77 0 0 1-1.71.33l-1 0c-.18 0-.6-.21-.7-.05-.24-.34-.98.09-.31.61Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.8b5c23fcd1521343f1ad3c8e55d41168.svg";
export { ForwardRef as ReactComponent };